import "./strip_hero.css";
